module.exports = __webpack_public_path__ + "static/media/LookingBack.51412d7a.jpg";